import type { ReactNode } from "react";
import InstructorPanelLayout from "./instructor-panel-layout";

export default function CourseAuthoringLayout({ children }: { children: ReactNode }) {
  return <InstructorPanelLayout>{children}</InstructorPanelLayout>;
}
